module.exports = __webpack_public_path__ + "img/组5102@2x.9b46ed4a.png";